import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/AutoManagedReportByDate.graphql';
import { Query, QueryautoManagedReportByDateArgs } from '../../__generated__/globalTypes';

export const useAutoManagedReportByDateQuery = (
  options?: QueryHookOptions<Query, QueryautoManagedReportByDateArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QueryautoManagedReportByDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useAutoManagedReportByDateLazyQuery = (
  options?: LazyQueryHookOptions<Query, QueryautoManagedReportByDateArgs>
): QueryResult<Query, QueryautoManagedReportByDateArgs> & {
  getAutoManagedReportByDate: LazyQueryExecFunction<Query, QueryautoManagedReportByDateArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getAutoManagedReportByDate, result] = useLazyQuery<Query, QueryautoManagedReportByDateArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getAutoManagedReportByDate, ...result };
};

export const useAutoManagedReportByDatePromiseQuery = () => {
  const client = useApolloClient();

  const getAutoManagedReportByDate = useCallback(
    (options?: Omit<QueryOptions<QueryautoManagedReportByDateArgs, Query>, 'query'>) =>
      client.query<Query, QueryautoManagedReportByDateArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getAutoManagedReportByDate };
};
// Suspense Query Hooks
export const useAutoManagedReportByDateSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QueryautoManagedReportByDateArgs>
) => {
  const result = useSuspenseQuery<Query, QueryautoManagedReportByDateArgs>(QUERY, {
    ...options
  });

  return result;
};
